import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Show = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M18.25 9.74c-3.908-6.85-12.592-6.85-16.475 0a.663.663 0 0 0 0 .658c3.892 6.85 12.575 6.85 16.475 0a.679.679 0 0 0 0-.667v.009Zm-8.242 4.242a3.909 3.909 0 1 1 0-7.818 3.909 3.909 0 0 1 0 7.818Z" />
      <Path d="M10 12.79a2.717 2.717 0 1 0 0-5.434 2.717 2.717 0 0 0 0 5.434Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(0 .073)" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Show
